<template>
  <div class="text-center">
    <v-progress-circular v-if="!ready" class="mt-2" indeterminate color="primary" size="100"></v-progress-circular>
    <iframe v-else :width="width" :height="height" :src="iFrameUrl" frameBorder="0"></iframe>
  </div>
</template>

<script>

export default {
  data() {
    return {
      url: this.$route.query.url,
      width: null,
      height: null,
      ready: false
    };
  },
  created() {
    this.width = window.innerWidth;
    this.height = window.innerHeight - 36;
    const d = new Date();
    let ms = d.getMilliseconds();
    this.iFrameUrl = this.url + '?ms=' + ms;
    this.ready = true;
  },
};
</script>

<style scoped></style>